import { FCC } from "@dgs/core";
import { ListItemTitleWrapper } from "./listComponents";

interface Props {
	className?: string;
}
export const ListItemTitle: FCC<Props> = ({ children, className }) => {
	return <ListItemTitleWrapper className={className}>{children}</ListItemTitleWrapper>;
};
